const routes = {
  DEFAULT: '/',
  LOGIN: '/',
  CONSENT: '/consent/:userType'
};

export default routes;
